import PropTypes from 'prop-types';
import './pageHeader.less';

const PageHeader = ({logoUrl}) => (
	<div className="navbar navbar-static-top navbar-default navbar-theme" role="navigation">
		<div className="container legacy-container">
			<div className="navbar-brand">
				{logoUrl && <img src={logoUrl} alt="Advisor Logo" />}
			</div>
		</div>
	</div>
);

PageHeader.propTypes = {
	logoUrl: PropTypes.string
};

export default PageHeader;
